import { tenantSdkClient } from './sdk';

let intervalId: ReturnType<typeof setInterval> | null = null;

async function sendHeartbeat(): Promise<void> {
  const { data } = await tenantSdkClient.auth.getSession();
  const token = data.session?.access_token;
  if (!token) return;
  fetch('/functions/v1/app/presence/heartbeat', {
    method: 'POST',
    headers: { authorization: `Bearer ${token}`, 'content-type': 'application/json' },
  }).catch(() => {});
}

export function startPresenceHeartbeat(): void {
  if (intervalId !== null) return;
  void sendHeartbeat();
  intervalId = setInterval(() => void sendHeartbeat(), 60_000);
}

export function stopPresenceHeartbeat(): void {
  if (intervalId !== null) {
    clearInterval(intervalId);
    intervalId = null;
  }
}
